const getters = {
    // sidebar: state => state.app.sidebar,
}
export default getters